export default "__VITE_ASSET__D$D46UJ6__"